import { createContext, useCallback, useContext } from 'react';

import { interpolateString } from 'support/helpers/strings/interpolateString';

type SchemableFormVariablesContextType = {
  variables: Record<string, string>;
};

export const SchemableFormVariablesContext = createContext<SchemableFormVariablesContextType | null>(null);

export const useInterpolateVariables = (): ((str: string) => string) => {
  const context = useContext(SchemableFormVariablesContext);

  return useCallback(
    (str: string) => {
      if (!context?.variables || Object.keys(context.variables).length === 0) {
        return str;
      }
      return interpolateString(str, context.variables);
    },
    [context?.variables],
  );
};
